/**
 * DOM element IDs used for printing functionality
 */
export const PRINT_ELEMENT_IDS = {
  WORKFLOW_STATUS: "WorkflowStatusForPrint",
  STEP_BODY: "StepBody"
} as const;
